import { Directive, ElementRef, EventEmitter, Output, inject } from '@angular/core';
import { GlobalEventsService } from '@coin/shared/core/util-helpers';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
  selector: '[coinAppClickedOutside]',
  standalone: true
})
export class ClickedOutsideDirective {
  private readonly elementRef = inject(ElementRef);
  private readonly events = inject(GlobalEventsService);

  @Output() clickedOutside = new EventEmitter<void>();

  constructor() {
    this.events
      .listen('click')
      .pipe(takeUntilDestroyed())
      .subscribe(event => {
        const targetElement = event.target as HTMLElement;
        if (
          targetElement?.parentElement &&
          !targetElement.parentElement.isEqualNode(this.elementRef.nativeElement) &&
          !this.elementRef.nativeElement.contains(targetElement)
        ) {
          this.clickedOutside.next();
        }
      });
  }
}
